import React from 'react';
import { Typography, Box } from '@mui/material';

function NotAuthorizedPage() {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="80vh">
      <Typography variant="h4" color="error">
        You are not authorized to view this page.
      </Typography>
    </Box>
  );
}

export default NotAuthorizedPage;
